import React from 'react';
import { useSelector } from 'react-redux';

import ContentTicker from '@swf/components/ContentTicker/ContentTicker';
import Translation from '@swf/components/Translation/Translation';
import { select } from '@swf/core/store';

import {
  TXTWCL_Information_on_the_percentage__ELL,
  TXTWCL_Players_must_be_at_least_N0_ye_ELL
} from './RegulatoryHeaderIT.messages.json';
import styles from './RegulatoryHeaderIT.scss';

const RegulatoryHeaderIT: React.FC = () => {
  const domain = useSelector(select.cms.getDomain);

  return (
    <ContentTicker className={styles.regulatoryHeader} interval={6}>
      <Translation values={{ 0: 18, 1: domain }} {...TXTWCL_Players_must_be_at_least_N0_ye_ELL} />
      <Translation
        values={{ 0: 'www.adm.gov.it', 1: domain }}
        {...TXTWCL_Information_on_the_percentage__ELL}
      />
    </ContentTicker>
  );
};

export default RegulatoryHeaderIT;
